
import { defineComponent, SetupContext, PropType, computed, ref } from "vue";
//import CommonRecipeTagList from "@/components/commonRecipe/CommonRecipeTagList.vue";
import CommonRecipeFoodIds from "@/components/commonRecipe/CommonRecipeFoodIds.vue";
import { getApplianceCategoryBlackIcon } from "@/utils/resource-util";
import { CommonRecipeTag, CommonRecipeFoodId } from "@/types/commonRecipe";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "CommonRecipeListItem",
  components: { 
    // CommonRecipeTagList
    CommonRecipeFoodIds
  },
  props: {
    /**
     * レシピ画像
     */
    recipeImageUrl: {
      type: String
    },
    /**
     * レシピ名
     */
    recipeLabel: {
      type: String,
      required: true
    },
    /**
     * レシピID
     */
    recipeId: {
      type: Number,
      required: true
    },
    /**
     * グループID
     */
    groupId: {
      type: Number,
      required: true
    },
    /**
     * レシピタイプ
     */
    recipeType: {
      type: String,
      required: true
    },
    /**
     * ApplianceCategory名
     */
    recipeApplianceCategory: {
      type: String,
      required: true
    },
    /**
     * ApplianceCategoryID
     */
    recipeApplianceCategoryId: {
      type: Number,
      required: true
    },
    /**
     * 項目の選択のボタン表示 0:ボタンなし、1:削除ボタン表示、2:選択ボタン表示
     */
    mode: {
      type: Number,
      default: 0
    },
    /**
     * タグ一覧
     */
    recipeTags: {
      type: Array as PropType<CommonRecipeTag[]>
    },
    /**
     * 食材一覧
     */
    recipeFoodIds: {
      type: Array as PropType<CommonRecipeFoodId[]>
    }
  },
  setup(props, context: SetupContext) {
    /**
     * レシピ名
     */
    const recipeTitle = props.recipeLabel.replace(/<br\/>/g, "");
    /**
     * 機種アイコンを取得する
     */
    const getCategoryIcon = (applianceCategoryId: number) => {
      const icon = getApplianceCategoryBlackIcon(applianceCategoryId);
      return icon;
    };

    /**
     * 検索タグを設定する
     */
    const selectRecipeTag = (tag: string) => {
      NativeClient.sendDebugLog("CommonRecipeListItem selectRecipeTag");
    };

    /**
     * レシピ情報の横幅
     */
    const styleRecipeInfoWidth = computed(() => {
      if (props.mode == 0) {
        NativeClient.sendDebugLog("CommonRecipeListItem select to Histories");
        return { width: `100%` };
      }
      return { width: `calc(100% - 4.8rem)` };
    });

    /**
     * 削除ボタン表示
     */
    const styleDeleteButton = computed(() => {
      if (props.mode == 0) {
        return { display: `none` };
      } else if (props.mode == 1) {
        return { display: `inline-box` };
      }
      return { display: `none` };
    });

    /**
     * 選択ボタン表示
     */
    const styleCheckButton = computed(() => {
      if (props.mode == 0) {
        return { display: `none` };
      } else if (props.mode == 1) {
        return { display: `none` };
      }
      return { display: `inline-box` };
    });

    // チェックボックス
    const isChecked = ref(false);
    const checkedImage = computed(() => {
      if (isChecked.value == false) {
        NativeClient.sendDebugLog("CommonRecipeListItem checked off");
        return require("@/assets/images/icn-check-off.png");
      }
      NativeClient.sendDebugLog("CommonRecipeListItem checked on");
      return require("@/assets/images/icn-check-on.png");
    });

    /**
     * ボタンのハンドラ底後
     */

    /**
     * レシピ選択
     */
    const selectAction = () => {
      NativeClient.sendDebugLog("CommonRecipeListItem select");
      context.emit('select-recipe', props.recipeId, props.recipeType);
    };

    /**
     * 削除
     */
    const deleteAction = () => {
      NativeClient.sendDebugLog("CommonRecipeListItem delete");
      context.emit('select-delete', props.recipeId);
    };

    /**
     * チェック
     */
    const checkAction = () => {
      NativeClient.sendDebugLog("CommonRecipeListItem check");
      if (isChecked.value == true) {
        isChecked.value = false;
        context.emit('select-check', props.recipeId, props.groupId, false);
      } else {
        isChecked.value = true;
        context.emit('select-check', props.recipeId, props.groupId, true);
      }
    };

    /**
     * 画像読み込みエラー発生
     */
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("CommonRecipeListItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("CommonRecipeListItem onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/noimage1.png"); 
      }
    };

    return {
      recipeTitle,
      getCategoryIcon,
      selectRecipeTag,
      onImageError,
      styleRecipeInfoWidth,
      styleDeleteButton,
      styleCheckButton,
      checkedImage,
      selectAction,
      deleteAction,
      checkAction
    };
  }
});
